/**
 * Remove leading slash / from a string
 */
export const removeLeadingSlash = (str) => str.replace(/^\//, '');
